// Yönetim panelinin bilgi mimarisi (v8).
//
// Eski menü 8 grup ve ~60 satırlık tek uzun listeydi: aynı işin sayfaları
// farklı başlıklara dağılmıştı (ör. Takım Birleştirme "Lig Yönetimi"nde, Takım
// Rehberi "Saha ve Planlama"da, Premium Onayları "Kullanıcılar ve Sistem"de),
// rol merkezleri (/yonetim/admin, /yonetim/il-yoneticisi…) menüyü kart olarak
// tekrar ediyordu. Artık:
//
//   • İş akışı (her zaman üstte): Talepler, Mesajlar, Yapılacaklar — rozetli.
//   • Ana sayfa: tek, role duyarlı Kontrol Paneli (/editor).
//   • 9 iş alanı bölümü; her bölüm kendi içinde alt başlıklara ayrılır.
//   • Araçlarım: kişisel araçlar lig yönetiminden ayrı, en altta.
//
// permissions alanı olan öğeler, kullanıcının o yetkilerden en az birine sahip
// olmadığı durumda gizlenir; roles alanı olanlar yalnızca o rollere görünür.
// Yetkiler admin panelindeki "Kullanıcı Yetkilendirme" ekranından verilir.
// keywords: komut paletinde (Ctrl/⌘ K) eş anlamlı aramalar için.
import { ACCOUNTING_PERMISSIONS, NATIONAL_ACCOUNTING_PERMISSIONS, hasAnyPermission } from "../utils/roleManagement";
import { LEAGUE_SETTINGS_PERMISSIONS } from "../features/leagueSettings/permissions";
import { DESKTOP_NAV_GROUP_KEYS, isDesktopApp } from "../utils/desktopApp";

export const DASHBOARD_PATH = "/editor";
export const ACCOUNT_PATH = "/yonetim/hesabim";
export const TODOS_PATH = "/yonetim/yapilacaklar";
export const TOOLS_PATH = "/yonetim/araclar";
export const MESSAGES_PATH = `${TOOLS_PATH}/mesajlar`;
export const REQUESTS_NAV_PATH = "/yonetim/talepler";
// Muhasebe merkezi: Hesaplar ve Virman, Ön Muhasebe, Maç Muhasebesi, Türkiye Geneli.
export const ACCOUNTING_PATH = `${TOOLS_PATH}/muhasebe`;
export const accountingSectionPath = (section) => `${ACCOUNTING_PATH}?bolum=${section}`;

// Eski rol merkezleri: tek Kontrol Paneli'ne yönlenir (App.js).
export const LEGACY_HUB_PATHS = ["/yonetim/admin", "/yonetim/editor", "/yonetim/il-yoneticisi", "/yonetim/lig-yoneticisi", "/yonetim/mac-yoneticisi"];

// Araçlar: her yönetim kullanıcısının kişisel çalışma araçları. Yetki
// gerekmez; kayıtlar yalnız sahibine görünür. Araçlar Merkezi bu listeyi
// kart olarak gösterir (Yapılacaklar ve Mesajlar dahil).
export const TOOL_ITEMS = [
  { key: "hub", name: "Araçlar Merkezi", path: TOOLS_PATH, icon: "toolbox", description: "Tüm araçlar ve bugünün özeti tek ekranda." },
  { key: "projects", name: "Projeler", path: `${TOOLS_PATH}/projeler`, icon: "project", description: "Süreç adımları ve sorumlular, soru-cevap, aranan kişiler, görüşme notları ve portföy tek yerde." },
  { key: "todos", name: "Yapılacaklar Listesi", path: TODOS_PATH, icon: "checklist", badge: "todos", description: "Görevler, hatırlatmalar, maç görevleri ve pano görünümü." },
  { key: "agenda", name: "Ajanda ve Takvim", path: `${TOOLS_PATH}/ajanda`, icon: "calendar", description: "Ay, hafta ve gün görünümü; tekrar eden etkinlikler ve hatırlatmalar." },
  { key: "notes", name: "Not Defteri", path: `${TOOLS_PATH}/not-defteri`, icon: "notebook", description: "Renkli notlar, işaretlenebilir listeler, etiket ve arşiv." },
  { key: "accounting", name: "Muhasebe", path: `${TOOLS_PATH}/muhasebe`, icon: "receipt", description: "Hesaplar ve virman, ön muhasebe, maç muhasebesi ve Türkiye geneli tek yerde." },
  { key: "sheets", name: "Tablolar", path: `${TOOLS_PATH}/tablolar`, icon: "sheet", description: "Formüllü hesap tabloları: TOPLA, EĞER, DÜŞEYARA… çoklu sayfa ve şablonlar." },
  { key: "messages", name: "Mesajlar", path: MESSAGES_PATH, icon: "message", description: "WhatsApp gibi sohbet: yöneticiler, takım başkanları, oyuncular ve üyelerle birebir yazışma ve gruplar; üyelerin ElitLig Yönetimi yazışmaları da burada." },
  { key: "contacts", name: "Rehber", path: `${TOOLS_PATH}/rehber`, icon: "contact", description: "Takımlar ve üyeler: takım adı öne çıkar; başkanlar, kadro, maçlar, tek dokunuşla ara, yaz, mesaj gönder." },
  { key: "calc", name: "Hesap Araçları", path: `${TOOLS_PATH}/hesap-araclari`, icon: "calculator", description: "KDV, yüzde, iskonto, aidat bölüştürme ve tarih hesapları." },
  { key: "focus", name: "Odak Sayacı", path: `${TOOLS_PATH}/odak-sayaci`, icon: "timer", description: "Pomodoro, geri sayım ve kronometre; maç süresi için de uygun." },
];

// İş akışında yer alan araçlar Araçlarım bölümünde tekrar edilmez.
const WORKFLOW_TOOL_KEYS = ["todos", "messages"];

const TOOL_KEYWORDS = {
  hub: "araçlar özet",
  projects: "süreç proje satış görüşme",
  agenda: "takvim etkinlik randevu",
  notes: "not liste",
  accounting: "gelir gider kasa virman ön muhasebe maç muhasebesi",
  sheets: "excel hesap tablosu",
  contacts: "telefon kişi başkan iletişim",
  calc: "kdv yüzde iskonto aidat",
  focus: "pomodoro kronometre geri sayım",
};

export const NAV_GROUPS = [
  {
    key: "is-akisi",
    label: "İş akışı",
    icon: "inbox",
    workflow: true,
    items: [
      // Talepler (onay merkezi): rozet toplam açık talep sayısıdır; ilgili
      // menü öğelerinde kategori sayısı da görünür (features/requests).
      { name: "Talepler", path: REQUESTS_NAV_PATH, icon: "inbox", badge: "requests", desc: "Onay bekleyen profil, transfer, kadro ve disiplin talepleri.", keywords: "onay bekleyen başvuru istek" },
      { name: "Mesajlar", path: MESSAGES_PATH, icon: "message", badge: "messages", desc: "Yönetim, takım ve üye yazışmaları.", keywords: "sohbet chat whatsapp yazışma" },
      { name: "Yapılacaklar", path: TODOS_PATH, icon: "checklist", badge: "todos", desc: "Görevlerin, hatırlatmaların ve maç görevlerin.", keywords: "görev todo hatırlatma iş listesi" },
    ],
  },
  {
    key: "genel",
    label: "Ana sayfa",
    icon: "home",
    items: [
      { name: "Kontrol Paneli", path: DASHBOARD_PATH, icon: "dashboard", desc: "Bugünün maçları, talepler, görevler ve kısayollar.", keywords: "genel bakış ana sayfa yönetim merkezi özet dashboard", aliases: LEGACY_HUB_PATHS, aliasExact: true },
    ],
  },
  {
    key: "lig",
    label: "Lig ve Sezon",
    short: "Lig",
    icon: "trophy",
    desc: "Lig yapısı, sezonlar, puan durumu ve kurallar.",
    items: [
      { sub: "Yapı", name: "Ligler", path: "/editor/ligler", icon: "trophy", permissions: ["leagues.create", "leagues.update", "leagues.delete", "leagues.archive"], keywords: "lig ekle arşiv" },
      { sub: "Yapı", name: "Sezonlar", path: "/editor/sezonlar", icon: "calendar", permissions: ["seasons.create", "seasons.update", "seasons.delete", "seasons.archive", "seasons.rule_set"], keywords: "sezon takvim dönem" },
      // Gruplar, Lig Ayarlamaları → Lig Statüsü bölümündedir.
      { sub: "Yapı", name: "Lig Statüsü ve Gruplar", path: "/editor/lig-ayarlari?bolum=lig-statusu", icon: "layers", permissions: ["groups.view", "groups.create", "groups.update", "groups.delete"], keywords: "grup eleme tur statü" },
      // Kural kitapçıkları; puanlama sistemi ve kadro kuralları da kitapçıktan yönetilir.
      // Eski adresler (/editor/kurallar, /editor/kadro-kural-setleri) çalışmaya devam eder.
      { sub: "Yapı", name: "Lig Ayarlamaları", path: "/editor/lig-ayarlari", icon: "book", permissions: LEAGUE_SETTINGS_PERMISSIONS, keywords: "kural kitapçığı puanlama kadro kuralı ayar", aliases: ["/editor/kurallar"] },
      { sub: "Rekabet", name: "Puan Durumu", path: "/editor/puan-durumu", icon: "standings", permissions: ["standings.update"], keywords: "tablo sıralama puan" },
      { sub: "Rekabet", name: "Kura Çekimi", path: "/yonetim/kura", icon: "shuffle", permissions: ["draws.view", "draws.run"], keywords: "kura torba eşleşme" },
      { sub: "Rekabet", name: "Junior Cup", path: "/yonetim/junior-cup", icon: "star", permissions: ["league_portals.view", "league_portals.manage"], keywords: "lig portalı turnuva portal" },
    ],
  },
  {
    key: "mac",
    label: "Maç Merkezi",
    short: "Maç",
    icon: "ball",
    desc: "Maçlar, saha planlama ve maç personeli.",
    items: [
      // Maç oluşturma ve eski maç adresleri de "Maçlar" altında sayılır.
      { sub: "Maçlar", name: "Maçlar", path: "/editor/maclar", icon: "ball", permissions: ["matches.view", "matches.create", "matches.update"], keywords: "fikstür maç programı skor sonuç kadro canlı reji", aliases: ["/editor/mac-olustur", "/editor/mac-guncelle", "/editor/ist-gir", "/editor/mac-ekle", "/editor/mac-paneli-beta", "/editor/canli-mac"] },
      { sub: "Maçlar", name: "Toplu Düzenle", path: "/editor/maclar/toplu-duzenle", icon: "pen", permissions: ["matches.bulk_edit"], keywords: "maçları toplu düzenle saat saha değiştir" },
      { sub: "Planlama", name: "Saha ve Maç Planlama", path: "/editor/sahalar", icon: "pin", permissions: ["venues.view", "venues.manage"], keywords: "saha saat havuz eşleştirme program" },
      { sub: "Planlama", name: "Takım Müsaitliği", path: "/editor/musaitlik", icon: "clock", permissions: ["venues.view"], keywords: "müsaitlik tablosu uygun gün saat" },
      { sub: "Personel ve görevlendirme", name: "Personel", path: "/yonetim/admin/personel", icon: "badge", permissions: ["staff.view"], keywords: "hakem spiker reji fotoğrafçı sağlıkçı" },
      { sub: "Personel ve görevlendirme", name: "Toplu Personel Atama", path: "/yonetim/admin/personel/toplu-atama", icon: "users", permissions: ["staff.assign"], keywords: "görevlendirme atama hakem ata" },
      { sub: "Personel ve görevlendirme", name: "Maç Değerlendirmeleri", path: "/yonetim/mac-degerlendirmeleri", icon: "clipboard", permissions: ["evaluations.view", "evaluations.submit", "evaluations.manage"], keywords: "performans form puan bonus kesinti" },
    ],
  },
  {
    key: "takim",
    label: "Takımlar ve Oyuncular",
    short: "Takım",
    icon: "shield",
    desc: "Takım ve oyuncu kayıtları, kadrolar ve transferler.",
    items: [
      { sub: "Kayıtlar", name: "Takımlar", path: "/editor/takimlar", icon: "shield", permissions: ["teams.create", "teams.update", "teams.delete"], keywords: "takım kulüp ekle logo" },
      { sub: "Kayıtlar", name: "Oyuncular", path: "/editor/oyuncular", icon: "users", permissions: ["players.create", "players.update", "players.delete"], keywords: "oyuncu futbolcu profil" },
      { sub: "Kayıtlar", name: "Takım Rehberi", path: "/editor/takim-rehberi", icon: "book", permissions: ["teams.directory"], keywords: "başkan iletişim telefon yetkili" },
      { sub: "Kadro ve transfer", name: "Kadro Listeleri", path: "/editor/kadro-listeleri", icon: "checklist", permissions: ["roster_rules.requests"], keywords: "tüm oyuncularım liste" },
      { sub: "Kadro ve transfer", name: "Kadro Onayları", path: "/editor/kadro-onaylari", icon: "check", permissions: ["roster_rules.requests"], keywords: "sezon kadrosu taslak onay" },
      { sub: "Kadro ve transfer", name: "Transfer Onayları", path: "/yonetim/admin/transfer-onaylari", icon: "swap", permissions: ["transfers.view", "transfers.review"], keywords: "transfer teklif onay" },
      { sub: "Kayıt birleştirme", name: "Takım Birleştirme", path: "/editor/takim-birlestirme", icon: "layers", permissions: ["teams.merge"], keywords: "mükerrer kopya takım birleştir" },
      { sub: "Kayıt birleştirme", name: "Oyuncu Birleştirme", path: "/editor/oyuncu-birlestirme", icon: "layers", permissions: ["players.merge"], keywords: "mükerrer kopya oyuncu birleştir" },
    ],
  },
  {
    key: "disiplin",
    label: "Disiplin",
    icon: "gavel",
    desc: "Cezalar, savunmalar ve itirazlar.",
    items: [
      { name: "Cezalar", path: "/editor/cezalar", icon: "gavel", permissions: ["penalties.view", "penalties.create"], keywords: "disiplin ceza kart men sevk" },
      { name: "Savunma ve İtirazlar", path: "/yonetim/admin/savunmalar", icon: "message", permissions: ["penalties.review"], keywords: "savunma itiraz cas kurul" },
    ],
  },
  {
    key: "icerik",
    label: "İçerik ve Medya",
    short: "İçerik",
    icon: "news",
    desc: "Haberler, görseller, ödüller ve yayın.",
    items: [
      { sub: "Yayın", name: "Haberler", path: "/editor/haberler", icon: "news", permissions: ["news.create", "news.update"], keywords: "haber duyuru yayınla" },
      { sub: "Yayın", name: "Yazı Ekle", path: "/editor/yazi-ekle", icon: "pen", permissions: ["news.writings"], keywords: "yazı köşe makale" },
      { sub: "Yayın", name: "İçerik Havuzu", path: "/icerik-havuzu", icon: "image", permissions: ["content.pool"], keywords: "görsel şablon sosyal medya paylaşım" },
      { sub: "Ödül ve yayın", name: "Haftanın Enleri", path: "/yonetim/haftanin-enleri", icon: "star", permissions: ["weekly_awards.view", "weekly_awards.update"], keywords: "ödül haftanın oyuncusu golcü", aliases: ["/admin/weekly-awards"] },
      { sub: "Ödül ve yayın", name: "Elitlig Panorama", path: "/yonetim/panorama", icon: "tv", permissions: ["panorama.view", "panorama.broadcast"], keywords: "yayın reji ekran panorama" },
      { sub: "Ödül ve yayın", name: "Final Tahmin Yönetimi", path: "/final-tahmin-yonetim", icon: "trending", permissions: ["content.final_tahmin"], keywords: "tahmin oran final oyun" },
    ],
  },
  {
    key: "ticari",
    label: "Ticari ve Finans",
    short: "Ticari",
    icon: "wallet",
    desc: "Sponsorlar, premium, finans ve piyasa değeri.",
    items: [
      { sub: "Gelir", name: "Sponsorlar", path: "/yonetim/sponsorlar", icon: "handshake", permissions: ["sponsors.view", "sponsors.manage"], keywords: "sponsor reklam led kaplama" },
      { sub: "Gelir", name: "Premium Onayları", path: "/editor/premium-onaylari", icon: "crown", permissions: ["users.membership"], keywords: "premium üyelik sipariş ödeme" },
      { sub: "Gelir", name: "Muhasebe", path: ACCOUNTING_PATH, icon: "receipt", permissions: [...ACCOUNTING_PERMISSIONS, ...NATIONAL_ACCOUNTING_PERMISSIONS], keywords: "gelir gider maç muhasebesi kasa türkiye geneli" },
      { sub: "Finans ve piyasa", name: "Takım Finansı & FFP", path: "/yonetim/takim-finans", icon: "coins", permissions: ["team_finance.view", "team_finance.manage"], keywords: "ffp bütçe finans takım" },
      { sub: "Finans ve piyasa", name: "Piyasa Değeri Yönetimi", path: "/yonetim/piyasa-degeri", icon: "chart", permissions: ["market_value.view", "market_value.recalculate", "market_value.settings"], keywords: "etl değer formül hesapla" },
      { sub: "Finans ve piyasa", name: "Piyasa Değeri Sıralaması", path: "/piyasa-degeri", icon: "trending", permissions: ["market_value.view"], keywords: "etl sıralama en değerli" },
    ],
  },
  {
    key: "uyeler",
    label: "Üyeler ve Yetkiler",
    short: "Üyeler",
    icon: "userCog",
    desc: "Site üyeleri, yönetim hesapları ve yetkiler.",
    items: [
      // İki ayrı ekran: "Üye Yönetimi" site üyelerini (oyuncu, takım başkanı),
      // "Yönetim Kullanıcıları" ise admin/editör gibi yetkili hesapları listeler.
      { sub: "Site üyeleri", name: "Üye Yönetimi", path: "/yonetim/admin/kullanicilar", icon: "users", permissions: ["users.view"], keywords: "üye kullanıcı kayıt hesap oyuncu başkan", aliases: ["/editor/uye-yonetimi"] },
      { sub: "Site üyeleri", name: "Şifre Sıfırlama Talepleri", path: "/yonetim/admin/sifre-talepleri", icon: "lock", permissions: ["users.password_reset"], keywords: "şifremi unuttum parola kod" },
      { sub: "Yönetim", name: "Yönetim Kullanıcıları", path: "/yonetim/admin/yonetim-kullanicilari", icon: "userPlus", permissions: ["management_users.view"], keywords: "admin editör il yöneticisi hesap aç", aliases: ["/editor/kullanici-ekle"] },
      { sub: "Yönetim", name: "Kullanıcı Yetkilendirme", path: "/yonetim/admin/yetkilendirme", icon: "key", permissions: ["permissions.view", "permissions.manage"], keywords: "yetki rol izin şablon" },
    ],
  },
  {
    key: "sistem",
    label: "Site ve Sistem",
    short: "Sistem",
    icon: "building",
    desc: "Şehirler, analiz, kayıtlar ve çöp kutusu.",
    items: [
      { sub: "Site", name: "Şehirler", path: "/yonetim/admin/sehirler", icon: "building", permissions: ["city_pages.manage"], keywords: "il şehir ekle harita" },
      { sub: "Site", name: "Şehir İletişim Sayfaları", path: "/yonetim/admin/iletisim", icon: "phone", permissions: ["city_pages.contacts"], keywords: "iletişim sosyal medya whatsapp" },
      { sub: "İzleme", name: "Ziyaretçi Analizi", path: "/yonetim/admin/ziyaretci-analizi", icon: "chart", permissions: ["analytics.view"], keywords: "analitik trafik ziyaretçi istatistik" },
      { sub: "İzleme", name: "İşlem Kayıtları", path: "/yonetim/admin/islem-kayitlari", icon: "clipboard", permissions: ["activity_logs.view"], keywords: "log kayıt denetim geçmiş" },
      { sub: "İzleme", name: "Çöp Kutusu", path: "/yonetim/admin/cop-kutusu", icon: "trash", permissions: ["trash.view"], keywords: "silinen geri al" },
    ],
  },
  {
    key: "araclar",
    label: "Araçlarım",
    short: "Araçlar",
    icon: "toolbox",
    tools: true,
    desc: "Kişisel çalışma araçların.",
    items: TOOL_ITEMS.filter((tool) => !WORKFLOW_TOOL_KEYS.includes(tool.key)).map((tool) => ({
      name: tool.name,
      path: tool.path,
      icon: tool.icon,
      desc: tool.description,
      keywords: TOOL_KEYWORDS[tool.key] || "",
    })),
  },
];

// Komut paletindeki işlemler (Ctrl/⌘ K). Yetkiye göre süzülür.
export const COMMAND_ACTIONS = [
  { key: "new-match", name: "Yeni maç oluştur", path: "/editor/mac-olustur", icon: "plus", permissions: ["matches.create"], keywords: "maç ekle fikstür" },
  { key: "new-news", name: "Haber yayınla", path: "/editor/haberler", icon: "news", permissions: ["news.create"], keywords: "yeni haber duyuru" },
  { key: "new-writing", name: "Yeni yazı ekle", path: "/editor/yazi-ekle", icon: "pen", permissions: ["news.writings"], keywords: "makale köşe" },
  { key: "new-penalty", name: "Yeni ceza gir", path: "/editor/cezalar/yeni", icon: "gavel", permissions: ["penalties.create"], keywords: "disiplin ceza ekle" },
  { key: "bulk-staff", name: "Maçlara personel ata", path: "/yonetim/admin/personel/toplu-atama", icon: "users", permissions: ["staff.assign"], keywords: "hakem spiker görevlendir" },
  { key: "run-draw", name: "Kura çek", path: "/yonetim/kura", icon: "shuffle", permissions: ["draws.run"], keywords: "kura torba" },
  { key: "new-todo", name: "Yeni görev ekle", path: TODOS_PATH, icon: "checklist", keywords: "yapılacak hatırlatma todo" },
  { key: "open-requests", name: "Bekleyen talepleri aç", path: `${REQUESTS_NAV_PATH}?durum=open`, icon: "inbox", keywords: "onay talep" },
  { key: "account", name: "Hesabım", path: ACCOUNT_PATH, icon: "user", keywords: "profil şifre güvenlik" },
  { key: "site", name: "Siteyi görüntüle", path: "/", icon: "external", keywords: "site ana sayfa elitlig" },
];

export const canSeeNavItem = (user, item) =>
  (!item.roles || item.roles.includes(user?.role)) &&
  (!item.excludeRoles || !item.excludeRoles.includes(user?.role)) &&
  (!item.permissions || hasAnyPermission(user, item.permissions)) &&
  (!item.hideWithPermissions || !hasAnyPermission(user, item.hideWithPermissions));

/** Türkçe harfleri sadeleştirir: "Çöp" → "cop", "MAÇLAR" → "maclar". */
export const foldText = (value = "") =>
  String(value)
    .toLocaleLowerCase("tr-TR")
    .replace(/ı/g, "i")
    .replace(/ş/g, "s")
    .replace(/ğ/g, "g")
    .replace(/ü/g, "u")
    .replace(/ö/g, "o")
    .replace(/ç/g, "c")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "");

// "ı" ve "i" aynı sayılır: eski bağlantılarda "/editor/maçlar" gibi yazımlar var.
const normalizePath = (value = "") => value.replace(/ı/g, "i").replace(/\/+$/, "") || "/";
const splitPath = (value = "") => {
  const [pathname, query = ""] = String(value).split("?");
  return { pathname: normalizePath(pathname), query };
};

const itemMatchesText = (item, group, words) => {
  if (!words.length) return true;
  const hay = foldText(`${item.name} ${group.label} ${item.sub || ""} ${item.keywords || ""}`);
  return words.every((word) => hay.includes(word));
};

const queryWords = (query) => foldText(query).split(/\s+/).filter(Boolean);

/** Yetkiye göre süzülmüş gruplar; boş kalan grup listeden düşer. */
export function visibleNavGroups(user, query = "", { desktop = isDesktopApp() } = {}) {
  const words = queryWords(query);
  // Mac masaüstü uygulaması yalnız iş akışı ve Araçlarım'ı gösterir (utils/desktopApp.js).
  const groups = desktop ? NAV_GROUPS.filter((group) => DESKTOP_NAV_GROUP_KEYS.includes(group.key)) : NAV_GROUPS;
  return groups.map((group) => {
    const items = group.items
      .filter((item) => canSeeNavItem(user, item))
      .filter((item) => itemMatchesText(item, group, words));
    return { ...group, items };
  }).filter((group) => group.items.length > 0);
}

/** Bölüm öğelerini alt başlıklarına göre sırasıyla toplar: [{ sub, items }]. */
export function subGroupsOf(items = []) {
  const out = [];
  items.forEach((item) => {
    const last = out[out.length - 1];
    if (last && last.sub === (item.sub || "")) last.items.push(item);
    else out.push({ sub: item.sub || "", items: [item] });
  });
  return out;
}

/** Görünür tüm sayfalar düz liste: [{ item, group }]. */
export const flattenNav = (groups) => groups.flatMap((group) => group.items.map((item) => ({ item, group })));

/** Yola karşılık gelen menü öğesi (sık kullanılanlar / son ziyaretler için). */
export function navEntryForPath(path, groups) {
  const target = normalizePath(String(path || ""));
  return flattenNav(groups).find(({ item }) => normalizePath(item.path) === target) || null;
}

/**
 * Komut paleti araması: sayfalar ve işlemler. Ad başta eşleşirse öne çıkar;
 * eş anlamlılar (keywords) ve bölüm adı da aranır. Türkçe harflere duyarsız.
 */
export function searchCommands(user, query, { groups = visibleNavGroups(user), limit = 30 } = {}) {
  const words = queryWords(query);
  const score = (name, hay) => {
    if (!words.length) return 1;
    if (!words.every((word) => hay.includes(word))) return 0;
    const folded = foldText(name);
    if (folded.startsWith(words.join(" "))) return 4;
    if (words.every((word) => folded.includes(word))) return 3;
    return 1;
  };
  const pages = flattenNav(groups).map(({ item, group }) => ({
    type: "page",
    id: `page:${item.path}`,
    name: item.name,
    path: item.path,
    icon: item.icon,
    section: group.label,
    score: score(item.name, foldText(`${item.name} ${group.label} ${item.sub || ""} ${item.keywords || ""}`)),
  }));
  const actions = COMMAND_ACTIONS.filter((action) => canSeeNavItem(user, action)).map((action) => ({
    type: "action",
    id: `action:${action.key}`,
    name: action.name,
    path: action.path,
    icon: action.icon,
    section: "İşlem",
    score: score(action.name, foldText(`${action.name} ${action.keywords || ""}`)),
  }));
  const all = [...actions, ...pages].filter((entry) => entry.score > 0);
  if (!words.length) return all.slice(0, limit);
  return all.sort((a, b) => b.score - a.score).slice(0, limit);
}

/**
 * Açık sayfaya en iyi uyan menü öğesi. Tam eşleşme yoksa en uzun ön ek
 * kazanır: "/editor/maclar/12/canli" sayfasında "Maçlar" seçili görünür.
 * Sorgulu öğeler ("?bolum=lig-statusu") yalnızca sorgu da uyduğunda seçilir.
 */
export function findActiveNav(pathname, groups, search = "") {
  const path = normalizePath(pathname);
  const params = new URLSearchParams(search || "");
  let best = null;
  let bestScore = -1;
  for (const group of groups) {
    for (const item of group.items) {
      const target = splitPath(item.path);
      if (target.query) {
        const wanted = new URLSearchParams(target.query);
        const ok = [...wanted.entries()].every(([key, value]) => params.get(key) === value);
        if (!ok) continue;
      }
      const exact = path === target.pathname;
      const prefix = !exact && target.pathname !== DASHBOARD_PATH && target.pathname !== "/yonetim" && path.startsWith(`${target.pathname}/`);
      const alias = !exact && !prefix && (item.aliases || []).some((a) => path === a || (!item.aliasExact && path.startsWith(`${a}/`)));
      if (!exact && !prefix && !alias) continue;
      // Sorgu uyan öğe aynı yolun sorgusuz öğesinin önüne geçer.
      const score = (alias ? 0 : target.pathname.length * 2) + (target.query ? 1 : 0) + (exact ? 1000 : 0);
      if (score > bestScore) { best = { group, item }; bestScore = score; }
    }
  }
  return best;
}
